"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useUniversalToken = useUniversalToken;
var _react = require("react");
var _constants = require("../constants");
var _internals = require("../internals");
var _getTokenClients = require("../internals/getTokenClients");
var _logger = require("../logger");
var _decodeToken = require("../utils/decodeToken");
var _isTokenValid = require("../utils/isTokenValid");
var initialAnonymousTokenState = {
    customerId: _constants.NOT_LOGGED_IN_USER_ID,
    cleanToken: undefined
};
var logger = _logger.mainLogger.createChild('useUniversalToken');
function useUniversalToken(param) {
    var customerId = param.customerId, initialToken = param.initialToken;
    var cleanInitialToken = initialToken ? (0, _internals.cleanToken)(initialToken) : undefined;
    var validInitialToken = cleanInitialToken && (0, _isTokenValid.isTokenValid)(cleanInitialToken) ? cleanInitialToken : undefined;
    var _ref = _sliced_to_array((0, _react.useState)(// Take customerId from props only when initial token is valid, otherwise just set the default (not logged in)
    validInitialToken ? {
        customerId: customerId,
        cleanToken: validInitialToken
    } : initialAnonymousTokenState), 2), tokenData = _ref[0], setTokenData = _ref[1];
    var _ref1 = _sliced_to_array((0, _react.useState)(false), 2), isUserVerified = _ref1[0], setIsUserVerified = _ref1[1];
    var updateTokenData = function(newTokenData) {
        var newToken = (newTokenData === null || newTokenData === void 0 ? void 0 : newTokenData.Token) ? (0, _internals.cleanToken)(newTokenData.Token) : undefined;
        var decodedToken = newToken ? (0, _decodeToken.decodeToken)(newToken) : null;
        setTokenData({
            customerId: (decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.customer_id) != null ? decodedToken.customer_id : _constants.NOT_LOGGED_IN_USER_ID,
            cleanToken: newToken
        });
    };
    // try to fetch new token if available on the first render (this will result in loading of the token and customerId of signed-in user)
    (0, _react.useEffect)(function() {
        var _ref = (0, _getTokenClients.getTokenClients)(), publicTokenClient = _ref.publicTokenClient, userTokenClient = _ref.userTokenClient;
        var tokenChangedListener = function(event) {
            return updateTokenData(event.detail.tokenData);
        };
        var fetchToken = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                4
                            ]);
                            return [
                                4,
                                userTokenClient.getToken()
                            ];
                        case 1:
                            updateTokenData.apply(void 0, [
                                _state.sent()
                            ]);
                            userTokenClient.bindTokenUpdated(tokenChangedListener);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            error = _state.sent();
                            return [
                                4,
                                publicTokenClient.getToken()
                            ];
                        case 3:
                            updateTokenData.apply(void 0, [
                                _state.sent()
                            ]);
                            publicTokenClient.bindTokenUpdated(tokenChangedListener);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchToken() {
                return _ref.apply(this, arguments);
            };
        }();
        // TODO(OL): There should be an abort controller
        fetchToken().catch(function(error) {
            logger.error(new Error("Some error occurred while getting token", {
                cause: error
            }));
            setTokenData(initialAnonymousTokenState);
        }).finally(function() {
            return setIsUserVerified(true);
        });
        return function() {
            publicTokenClient.unbindTokenUpdated(tokenChangedListener);
            userTokenClient.unbindTokenUpdated(tokenChangedListener);
        };
    }, []);
    return (0, _react.useMemo)(function() {
        var _tokenData_cleanToken, _tokenData_customerId;
        return {
            token: (_tokenData_cleanToken = tokenData.cleanToken) !== null && _tokenData_cleanToken !== void 0 ? _tokenData_cleanToken : '',
            // TODO (JN): This should be nullable to reflect the real state of the app. Consumers then may decide what to do when token is not available. But it is going to be a breaking change.
            customerId: (_tokenData_customerId = tokenData.customerId) !== null && _tokenData_customerId !== void 0 ? _tokenData_customerId : _constants.NOT_LOGGED_IN_USER_ID,
            formattedToken: tokenData.cleanToken ? "Bearer ".concat(tokenData.cleanToken) : '',
            isAnonymousUser: tokenData.customerId === _constants.NOT_LOGGED_IN_USER_ID,
            isUserVerified: isUserVerified
        };
    }, [
        tokenData.customerId,
        tokenData.cleanToken,
        isUserVerified
    ]);
} //# sourceMappingURL=useUniversalToken.js.map
